import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetCollectionTriageNextV2Response } from '../getCollectionTriageNextV2/get-collection-triage-next-v2-response';
import { getCollectionTriageNextV2ResponseSchema } from '../getCollectionTriageNextV2/get-collection-triage-next-v2-response';
import type { IGetCollectionTriageClipV2Request } from './get-collection-triage-clip-v2-request';

/**
 * @deprecated Superseded by `getCollectionTriageClipV3Api`. Frozen, not deleted -
 * an old app binary may still call it. See "Web-only / orphan versions pending
 * deletion" in apps/api/CLAUDE.md.
 */
export async function getCollectionTriageClipV2Api({
  collectionId,
  clipId,
}: IGetCollectionTriageClipV2Request): Promise<
  IValidatedResponse<IGetCollectionTriageNextV2Response>
> {
  return getRequest<IGetCollectionTriageNextV2Response>({
    path: `/sys/collections/${collectionId}/triage/clip/v2?clipId=${clipId}`,
    schema: getCollectionTriageNextV2ResponseSchema,
  });
}
